<template>
  <v-card outlined>
    <v-card-title>
      CAJEROS | SUPERVISORES | ADMINISTRADORES
      <v-spacer/>
      <v-btn
          color="primary"
          @click="openForm(null)"
      >
        + Nuevo
      </v-btn>
    </v-card-title>
    <v-divider/>
    <v-card-text>
      <v-row>
        <v-col cols="12" md="11">
          <v-text-field
              v-model="txtBuscar"
              append-icon="mdi-magnify"
              label="Buscar"
              single-line
              hide-details
          />
        </v-col>
        <v-col cols="12" md="1" class="text-right">
          <v-btn color="accent" class="ma-3" title="Actualizar cajeros" outlined @click="listar()">
            <v-icon>mdi-update</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-data-table
          class="mt-5"
          :headers="headers"
          :items="cajeros"
          :loading="loading"
          :search="txtBuscar"
          dense
          :items-per-page="100000"
          :hide-default-footer="true"
      >
        <template v-slot:item.numero="{ item }">
          {{ cajeros.indexOf(item) + 1 }} ( {{ item.user?.id }} )
        </template>
        <template v-slot:item.rol="{ item }">
          <v-chip
              v-for="permission in item.user?.permissions" :key="permission.id"
              small
              class="ml-1"
          >
            {{ permission.name }}
          </v-chip>
        </template>
        <template v-slot:item.estado="{ item }">
          <v-chip
              v-if="item.user?.alta"
              color="success"
              dark
              small
          >
            Activo
          </v-chip>
          <v-chip
              v-else
              color="error"
              dark
              small
          >
            Baja
          </v-chip>
        </template>
        <template v-slot:item.acciones="{ item }">
          <v-btn
              v-if="item.user?.alta"
              color="primary"
              dark
              small
              icon
              title="Modificar"
              @click="openForm(item)"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
              dark
              small
              icon
              title="Alta / Baja"
              @click="cambiarEstado(item)"
          >
            <v-icon v-if="item.user?.alta" color="error" title="Dar de alta">mdi-arrow-down-bold</v-icon>
            <v-icon v-else title="Dar de baja" color="success">mdi-arrow-up-bold</v-icon>
          </v-btn>
        </template>
      </v-data-table>
<!--      <pre>{{cajeros}}</pre>-->
    </v-card-text>

    <v-dialog v-model="showDialog" persistent width="700px">
      <CajeroForm @close="closeForm()" />
    </v-dialog>

  </v-card>
</template>

<script lang="ts">
import {Component, Vue} from "vue-property-decorator";
import {cajeroStore} from "@/store/cajeroStore";
import {Cajero} from "@/models/Cajero";
import {CajeroService} from "@/services/CajeroService";
import {Alert} from "@/addons/Alert";
import CajeroForm from "@/views/cajeros/CajeroForm.vue";

@Component({
  name: "CajeroIndex",
  components: {CajeroForm}
})
export default class CajeroIndex extends Vue {
  private cajeroStore = cajeroStore();
  private cajeroService = CajeroService.getInstance();
  private txtBuscar = "";
  private headers = [
    {text: "Nro.", value: "numero"},
    {text: "CI", value: "user.email"},
    {text: "Ventanilla", value: "ventanilla"},
    {text: "Nombre Completo", value: "user.funcionario.nombre_completo"},
    {text: "Entidad", value: "entidad"},
    {text: "Sucursal", value: "sucursal"},
    {text: "% cobros", value: "cantidad_factura", align:"center"},
    {text: "Rol", value: "rol"},
    {text: "Estado", value: "estado"},
    {text: "Acciones", value: "acciones"}
  ];

  get cajeros(): Cajero[] {
    return this.cajeroStore.cajeros;
  }

  get loading(): boolean {
    return this.cajeroStore.loading;
  }

  get showDialog(): boolean {
    return this.cajeroStore.showDialog;
  }

  mounted(): void {
    this.listar();
  }

  private listar() {
    this.cajeroService.index();
  }

  cambiarEstado(cajero: Cajero){
    Alert.confirm("Seguro que quire cambiar el estado del cajero?").then(res => {
      if(res.isConfirmed){
        this.cajeroService.destroy(cajero.id);
      }
    });
  }

  openForm(cajero: Cajero) {
    if(cajero === null)
      this.cajeroStore.cajero = new Cajero();
    else
      this.cajeroStore.cajero = cajero;

    this.cajeroStore.showDialog = true;
  }

  closeForm(){
    this.cajeroStore.showDialog = false;
    this.listar();
  }
}
</script>

<style scoped>

</style>